import { JSONContent } from "@tiptap/core";

export interface ReadTimeOptions {
  /**
   * среднее кол-во слов, которое человек читает в минуту
   * @default 110
   */
  wpm: number;
  /**
   * время в секундах, которое уходит на просмотр одного изображения
   * @default 10
   */
  image: number;
  /**
   * возвращает значение в минутах или секундах
   * @default "minutes"
   */
  format: "minutes" | "seconds";
}

/** Рендерит только текстовые ноды из формата редактора */
export function getReadTime(
  json: JSONContent | undefined,
  options: ReadTimeOptions = { format: "minutes", image: 10, wpm: 110 }
): number {
  const seconds = traverseJson(json, options);

  if (options.format === "seconds") {
    return Math.round(seconds);
  }

  return Math.round(seconds / 60) || 1;
}

function traverseJson(
  node: JSONContent | undefined,
  options: ReadTimeOptions
): number {
  if (node?.type === "text" && typeof node.text === "string") {
    const words = node.text.split(/[/\n ]/).filter(Boolean).length;

    return (words / options.wpm) * 60;
  }

  if (node?.type === "imageResize") {
    return options.image;
  }

  if (node?.type === "carouselItem") {
    return options.image;
  }

  if (node?.content) {
    return node.content.reduce(
      (acc, item) => acc + traverseJson(item, options),
      0
    );
  }

  return 0;
}
